// Number & date formatters (locale id-ID)

export function formatRupiahFull(n) {
  const num = Number(n || 0);
  return "Rp " + Math.round(num).toLocaleString("id-ID");
}

// Short format used on chips & daily subtotal (e.g. Rp 5,2jt / Rp 1,3M)
export function formatRupiahShort(n) {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  const sign = num < 0 ? "-" : "";
  if (abs >= 1_000_000_000) {
    return `${sign}Rp ${(abs / 1_000_000_000).toFixed(1).replace(".", ",").replace(",0", "")}M`;
  }
  if (abs >= 1_000_000) {
    return `${sign}Rp ${(abs / 1_000_000).toFixed(1).replace(".", ",").replace(",0", "")}jt`;
  }
  if (abs >= 1_000) {
    return `${sign}Rp ${(abs / 1_000).toFixed(0)}rb`;
  }
  return `${sign}Rp ${abs.toLocaleString("id-ID")}`;
}

// Signed subtotal: +Rp 20jt / -Rp 5,7jt
export function formatRupiahSigned(n, sign) {
  const prefix = sign === "+" ? "+" : sign === "-" ? "-" : n >= 0 ? "+" : "-";
  return `${prefix}${formatRupiahShort(Math.abs(n))}`;
}

const BULAN_ID = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

export function formatTanggalID(ymd) {
  if (!ymd) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  return `${d} ${BULAN_ID[m - 1]} ${y}`;
}

export function formatBulanID(bulan) {
  if (!bulan) return "";
  const [y, m] = bulan.split("-").map(Number);
  return `${BULAN_ID[m - 1]} ${y}`;
}

export function todayYMD() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function currentBulan() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function shiftBulan(bulan, delta) {
  const [y, m] = bulan.split("-").map(Number);
  const date = new Date(y, m - 1 + delta, 1);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

// Parse "50.000" or "50000" -> 50000
export function parseNominal(s) {
  if (typeof s === "number") return s;
  const clean = String(s || "").replace(/[^\d]/g, "");
  return clean ? Number(clean) : 0;
}

// Live-format input: 50000 -> "50.000"
export function formatNominalInput(s) {
  const n = parseNominal(s);
  return n ? n.toLocaleString("id-ID") : "";
}
